<template>
  <thead class="v-data-table-header zoox-component zoox-table-header">
    <tr>
      <template v-for="header in headers">
        <th
          :key="header.value"
          class="column"
          :style="{
            backgroundColor: header.color,
            textAlign: header.align,
            ...setHeaderWidth(header.width),
            ...styles,
          }"
          :class="[header.sortable ? 'sortable' : '', header.class || '']"
          @click="header.sortable ? onChangeSort(header.value) : ''"
        >
          <slot :name="`header.${header.value}`" v-bind="header">
            {{ header.text }}
            <v-icon v-if="header.sortable" small>$unfold_more_rounded</v-icon>
          </slot>

          <slot :name="`header.${header.value}-extra`" v-bind="header"></slot>
        </th>
      </template>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'ZTableHeader',
  props: {
    headers: {
      type: Array,
      required: true,
    },

    styles: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods: {
    onChangeSort(column) {
      /**
       * Emitido quando o header é clicado para fazer
       * sorting
       */
      this.$emit('sort', column)
    },

    setHeaderWidth(width) {
      if (!width) {
        return undefined
      } else if (isNaN(+width)) {
        return {
          width: String(width),
          minWidth: String(width),
        }
      } else {
        return {
          width: `${Number(width)}px`,
          minWidth: `${Number(width)}px`,
        }
      }
    },
  },
}
</script>
